import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { useGetReviewWorker } from '@/modules/workforce/workersTimesheet/apiHooks';
import { IdentityCard } from '@/modules/workforce/workersTimesheet/components/Modals/VerifyWorkerImage/IdentiyCard';
import { IWorkersTimesheet } from '@/modules/workforce/workersTimesheet/types';
import { Loading } from '@/shared/components/atoms';
import { useStore } from '@/shared/hooks/context/createGenericContext';

interface IProps {
  attendanceRow: IWorkersTimesheet.IAttendanceTimesheetItem;
  date: string;
  action: 'show' | 'review';
}
export function VerifyWorkerImage({ attendanceRow, date, action }: IProps) {
  const [selectedAsset] = useStore((store) => store?.asset);
  const { t } = useTranslation('common');

  /********************************* api *************************************** */
  const { data: identities, isLoading } = useGetReviewWorker({
    workerId: attendanceRow.workerId,
    date,
    entityId: selectedAsset?.id,
  });
  /********************************* logic *************************************** */
  const isVerifiedCheckin = useMemo(
    () => attendanceRow?.attendance.isFaceVerified,
    [attendanceRow?.attendance.isFaceVerified]
  );
  const isVerifiedCheckout = useMemo(
    () => attendanceRow?.dismissal.isFaceVerified,
    [attendanceRow?.dismissal.isFaceVerified]
  );

  if (isLoading) {
    return <Loading />;
  }

  return (
    <div>
      <div className='flex flex-col items-start justify-between  gap-16  tablet:flex-row'>
        <IdentityCard
          attendanceRow={attendanceRow}
          cardType='profile'
          imageSrc={identities?.profilePicture || ''}
          title={t('face-id')}
        />
        <div className=' flex flex-col items-start justify-between gap-16  tablet:flex-row tablet:ltr:ml-16  tablet:rtl:mr-16 '>
          <IdentityCard
            cardType='checkin'
            attendanceRow={attendanceRow}
            imageSrc={identities?.attendance?.image || ''}
            takenBy={identities?.attendance?.takenBy || ''}
            verifiedBy={identities?.attendance?.verifiedBy || ''}
            fraudBy={identities?.attendance?.fraudBy || ''}
            isVerified={isVerifiedCheckin}
            title={t('check-in-photo')}
            date={date}
            action={action}
            hasPP={Boolean(identities?.profilePicture)}
          />
          <IdentityCard
            cardType='checkout'
            title={t('check-out-photo')}
            attendanceRow={attendanceRow}
            imageSrc={identities?.dismissal?.image || ''}
            takenBy={identities?.dismissal?.takenBy || ''}
            verifiedBy={identities?.dismissal?.verifiedBy || ''}
            fraudBy={identities?.dismissal?.fraudBy || ''}
            isVerified={isVerifiedCheckout}
            date={date}
            action={action}
            hasPP={Boolean(identities?.profilePicture)}
          />
        </div>
      </div>
    </div>
  );
}
